import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import languages from '@/assets/data/language'
import Button from '@/components/Button'
import Dialog from '@/components/Dialog'
import { useCreateProfileMutation } from '@/store/apiService'
import httpService from '@/utils/httpService'

import Select from '../Select'

interface LanguageDialogProps {
  isOpen: boolean
  onClose: () => void
  currentLanguage: string
  profileResponse?: any
}

const LanguageDialog: React.FC<LanguageDialogProps> = ({
  isOpen,
  onClose,
  currentLanguage,
  profileResponse,
}) => {
  const { i18n } = useTranslation()
  const [selectedLang, setSelectedLang] = useState(currentLanguage)
  const [updateProfile] = useCreateProfileMutation()

  useEffect(() => {
    if (isOpen) {
      setSelectedLang(currentLanguage)
    }
  }, [isOpen, currentLanguage])

  const handleSave = () => {
    i18n.changeLanguage(selectedLang)
    localStorage.setItem('i18nCode', selectedLang)
    httpService.defaults.headers['Accept-Language'] = selectedLang

    if (profileResponse) {
      updateProfile({ ...profileResponse, language: selectedLang }).catch(
        (err) => console.error('Failed to update profile language:', err),
      )
    }
    toast.success('Language has been updated.')

    onClose()
  }

  return (
    <Dialog
      triggerElement={null}
      isOpen={isOpen}
      onClose={onClose}
      title={'Select a Language'}
      maxWidth="xl"
      paperStyles={{ width: '800px' }}
      content={
        <Select
          options={languages.map((lang) => ({
            value: lang.id,
            text: lang.label,
          }))}
          name={'language'}
          value={selectedLang}
          onFormValueChange={(_, value) => setSelectedLang(value)}
          placeholder="Select a language"
        />
      }
      actionButtons={
        <>
          <Button variant="outlined" label={'Cancel'} onClick={onClose} />
          <Button variant="contained" label={'Save'} onClick={handleSave} />
        </>
      }
    />
  )
}

export default LanguageDialog
